import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 查询入住列表
export function queryhomebedelderly (params, data) {
  params.token = getToken()
  return request({ url: '/queryhomebedelderly', method: 'post', params, data })
}

// 查询预约入住
export function accomodationgetbedwait (params, data) {
  params.token = getToken()
  return request({ url: '/accomodationgetbedwait', method: 'post', params, data })
}

// 预约入住(增删改)
export function accomodationupdatebedwait (data) {
  return request({ url: '/accomodationupdatebedwait', method: 'post', params: { token: getToken() }, data })
}

// 老人入住(绑定床位)
export function bindhomebedelderly (data) {
  return request({ url: '/bindhomebedelderly', method: 'post', params: { token: getToken() }, data })
}

// 老人入住信息更改（除更换床位）
export function updatehomebedelderly (data) {
  return request({ url: '/updatehomebedelderly', method: 'post', params: { token: getToken() }, data })
}

// 换床位
export function accomodationchangebed (data) {
  return request({ url: '/accomodationchangebed', method: 'post', params: { token: getToken() }, data })
}

// 查询请假信息
export function accomodationgetleaveinfo (data) {
  return request({ url: '/accomodationgetleaveinfo', method: 'post', params: { token: getToken() }, data })
}

// 请假
export function accomodationaskleave (data) {
  return request({ url: '/accomodationaskleave', method: 'post', params: { token: getToken() }, data })
}

// 取消请假
export function accomodationaskleavecancel (data) {
  return request({ url: '/accomodationaskleavecancel', method: 'post', params: { token: getToken() }, data })
}

// 申请退住
export function accomodationcheckoutapply (data) {
  return request({ url: '/accomodationcheckoutapply', method: 'post', params: { token: getToken() }, data })
}

// 取消退住
export function accomodationcheckoutapplycancel (data) {
  return request({ url: '/accomodationcheckoutapplycancel', method: 'post', params: { token: getToken() }, data })
}

// 审批退住
export function accomodationcheckoutapprove (data) {
  return request({ url: '/accomodationcheckoutapprove', method: 'post', params: { token: getToken() }, data })
}

// 查询入住事件
export function accomodationgetevents (params, data) {
  params.token = getToken()
  return request({ url: '/accomodationgetevents', method: 'post', params, data })
}

// 查询探视记录
export function accomodationgetbedvisit (params, data) {
  params.token = getToken()
  return request({ url: '/accomodationgetbedvisit', method: 'post', params, data })
}

// 增删改探视预约
export function accomodationupdatebedvisit (data) {
  return request({ url: '/accomodationupdatebedvisit', method: 'post', params: { token: getToken() }, data })
}

// 探视确认（放行）
export function accomodationconfirmbedvisit (data) {
  return request({ url: '/accomodationconfirmbedvisit', method: 'post', params: { token: getToken() }, data })
}

// 入住统计
export function accomodationgethomebedstat (params, data) {
  params.token = getToken()
  return request({ url: '/accomodationgethomebedstat', method: 'post', params, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/homebed.js